import { useState } from "react";
import axios from "axios";
import { MessageCircle, Loader2, Send, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { API, inputCls, btnGhost, apiError } from "@/lib/studioApi";

export const PublicQuestion = ({ path, docLabel, defaultName = "", defaultEmail = "" }) => {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState(defaultName);
  const [email, setEmail] = useState(defaultEmail);
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const send = async () => {
    if (!name.trim() || message.trim().length < 5) { toast.error("Indiquez votre nom et votre question."); return; }
    setBusy(true);
    try {
      await axios.post(`${API}${path}/question`, { name, email, message });
      setSent(true);
    } catch (e) { toast.error(apiError(e, "Envoi impossible. Réessayez.")); } finally { setBusy(false); }
  };

  if (sent) {
    return (
      <div data-testid="public-question-sent" className="mt-6 rounded-2xl border border-emerald-200 bg-emerald-50 p-5 text-sm text-emerald-800 inline-flex items-center gap-2">
        <CheckCircle2 className="w-4 h-4 shrink-0" /> Question envoyée. L'entreprise vous répond par e-mail dans les meilleurs délais.
      </div>
    );
  }

  return (
    <div data-testid="public-question-block" className="mt-6 rounded-2xl border border-[#E2E7F7] bg-white p-5 shadow-[0_1px_2px_rgba(15,38,69,0.04)]">
      <button type="button" data-testid="public-question-toggle" onClick={() => setOpen((o) => !o)} className="flex w-full items-center justify-between gap-3 text-left">
        <span className="font-heading text-base font-semibold text-[#0F2645] inline-flex items-center gap-2"><MessageCircle className="w-4 h-4 text-[#3A5CC8]" /> Une question sur {docLabel} ?</span>
        <span className="text-xs font-semibold text-[#3A5CC8]">{open ? "Fermer" : "Poser ma question"}</span>
      </button>
      {open && (
        <div className="mt-4 space-y-3">
          <div className="grid gap-3 sm:grid-cols-2">
            <input data-testid="public-question-name" className={inputCls} placeholder="Votre nom *" value={name} onChange={(e) => setName(e.target.value)} />
            <input data-testid="public-question-email" type="email" className={inputCls} placeholder="Votre e-mail pour la réponse" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <textarea data-testid="public-question-message" rows={3} className={inputCls} placeholder="Ex. : le délai d'intervention est-il garanti ? La TVA à 6 % s'applique-t-elle ?" value={message} onChange={(e) => setMessage(e.target.value)} />
          <div className="flex flex-wrap items-center gap-3 pr-14 sm:pr-0">
            <button type="button" data-testid="public-question-send" disabled={busy} onClick={send} className={btnGhost}>
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Envoyer ma question
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
